import { parseQueryArray } from '@/utils/parse-query';
import { REVIEW_LABELS } from '@/constants/reviews';

export const REVIEWS_QUERY_PARAMS = {
  TOKEN: 'token',
  JOB_ID: 'job_id',
  SKILLS_PROFILES: 'skills_profiles',
  RATING: 'rating',
  PROFILE_ID: 'profile_id',
};

export default {
  REVIEWS_QUERY_PARAMS,
  REVIEW_LABELS,
  computed: {
    token () {
      return this.$route.query[this.$options.REVIEWS_QUERY_PARAMS.TOKEN];
    },
    jobId () {
      return this.$route.query[this.$options.REVIEWS_QUERY_PARAMS.JOB_ID];
    },
    skillsProfiles () {
      return parseQueryArray(this.$route.query[this.$options.REVIEWS_QUERY_PARAMS.SKILLS_PROFILES]);
    },
    rating () {
      const rating = this.$route.query[this.$options.REVIEWS_QUERY_PARAMS.RATING];

      return rating && parseInt(rating, 10);
    },
    profileId () {
      return this.$route.query[this.$options.REVIEWS_QUERY_PARAMS.PROFILE_ID];
    },
  },
};
